import { useEffect, useState } from 'react';
import { pmt2Service, FarmingResultsData } from '@/services/pmt2Service';

interface UseFarmingResultsDataResult {
  data: FarmingResultsData | null;
  isLoading: boolean;
  error: Error | null;
}

export function usePmt3FarmingResultsData(
  companyName?: string,
  asin?: string
): UseFarmingResultsDataResult {
  const [data, setData] = useState<FarmingResultsData | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!companyName || !asin) {
      setData(null);
      setIsLoading(false);
      setError(null);
      return;
    }

    setIsLoading(true);
    setError(null);

    pmt2Service
      .getFarmingResultsData(companyName, asin)
      .then((result) => {
        setData(result);
        setError(null);
      })
      .catch((err) => {
        console.error('Error fetching Farming Results data:', err);
        setError(err instanceof Error ? err : new Error(String(err)));
        setData(null);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [companyName, asin]);

  return { data, isLoading, error };
}